module.exports = __webpack_public_path__ + "img/support-savedsearch-dark.66f47f87.png";